<template>
  <div>
    <div v-if="loadingData">
      <v-row class="text-center" align="center" justify="center">
        <v-progress-circular
          :indeterminate="true"
          :rotate="0"
          :size="32"
          :width="4"
          color="light-blue"
        ></v-progress-circular>
      </v-row>
      <v-row class="text-center" align="center" justify="center">
        Caricamento in corso....
      </v-row>
    </div>

    <div v-if="!loadingData">
      <v-row class="form-title" align="center" justify="center"
        ><h2 class="header-title-h2">
          Complimenti. La configurazione del suo sito è terminata.
        </h2></v-row
      >
      <v-row class="form-title" align="center" justify="center">
        <h3>
          Le chiediamo gentilmente di spendere qualche minuto per leggere e
          confermare l'accordo con Aki Italia s.r.l. e verificare le caratteristiche
          del servizio che le viene offerto.
        </h3></v-row
      >

      <v-card
        id="licenseAgreement"
        v-scroll.self="onScroll"
        class="overflow-y-auto"
        max-height="400"
      >
        <v-card-text class="text-left" v-html="eula">
        </v-card-text>
      </v-card>
    </div>

    <div class="form-spacer" />

    <v-row class="text-center" align="center" justify="center">
      <v-btn
        v-if="!agreementConfirmed"
        class="ml-2"
        @click="goBack()"
        color="primary"
        >Indietro</v-btn
      >
      <v-btn
        :disabled="!agreementScrolled"
        v-if="!agreementConfirmed"
        class="ml-2 white--text"
        @click="acceptAgreement($event)"
        color="secondary"
      >
        Accetta
      </v-btn>
      <v-progress-circular
        v-if="agreementConfirmed"
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<style scoped>
.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.service-row {
  background-color: #f5f5f5;
  font-size: 18px;
  margin-left: 2px;
  margin-right: 2px;
}

.service-card {
  padding: 5px;
}

.form-spacer {
  height: 30px;
}

.service-check {
  margin-top: 0px;
  margin-bottom: 0px;
}

.eula {
  font-size: 14px;
}
</style>

<script>
import store from "../../store";
import config from "../../config";

export default {
  data() {
    return {
      loadingData: true,
      agreementConfirmed: false,
      services: [],
      eula: config["Eula"],
      agreementScrolled: true,
    };
  },

  mounted() {
    this.loadingData = false;
  },

  methods: {
    onScroll() {
      let id = document.getElementById("licenseAgreement");
      if (id.scrollTop >= id.scrollHeight-id.offsetHeight) {
        this.agreementScrolled = true;
      }
    },

    acceptAgreement() {
      this.agreementConfirmed = true;
      let completedStep = this.$store.state.wizard.completedStep;
      if (completedStep < this.$store.state.wizard.selectedStep)
        completedStep = this.$store.state.wizard.selectedStep;

      store
        .dispatch("setWizardSteps", {
          completedStep: completedStep,
          selectedStep: this.$store.state.wizard.selectedStep + 1,
          meta: {},
        })
        .then(() => {
          this.agreementConfirmed = false;
        });
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },
  },
};
</script>
